import * as Projects from "./projects";
import * as User from "./user";
import * as CurrentResponses from "./currentResponses";
import * as Logged from "./logged";
import { combineReducers, createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";

export interface AppState {
  projects: Projects.State;
  currentReponses: CurrentResponses.State;
  user: User.State;
  logged: Logged.State;
}

export const initialState: AppState = {
  projects: Projects.initialState,
  currentReponses: CurrentResponses.initialState,
  user: User.initialState,
  logged: Logged.initialState
};

/**
 * app reducer handles all actions but logout
 */
export const appReducer = combineReducers({
  projects: Projects.reducer,
  currentReponses: CurrentResponses.reducer,
  user: User.reducer,
  logged: Logged.reducer
});

/**
 * root reducer can reset store
 */
export const rootReducer = (state, action) => {
  if (action.type === "RESET_STORE") {
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

// Plug redux dev tool in development mode only
// See https://github.com/zalmoxisus/redux-devtools-extension
export const composeEnhancers =
  process.env.NODE_ENV === "development"
    ? (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
    : compose;

// Encapsulate createStore in an exported function, so we can create independant stores in test suite
export function createNewStore() {
  return createStore(
    rootReducer,
    initialState,
    composeEnhancers(applyMiddleware(thunk))
  );
}

export const store = createNewStore();



// WEBPACK FOOTER //
// ./src/redux/store.ts